new Glide(".quick-buy-slider", {
  type: "slider",
  rewind: false,
  perView: 2,
  gap: 0,
  breakpoints: {
    900: {
      perView: 1,
    },
  },
}).mount()

const productLinks = document.querySelectorAll(".js-create-link")
productLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    if (
      e.target === link.querySelector("span") ||
      e.target === link.querySelector("button") ||
      e.target === link.querySelector(".ajaxified-cart-feedback")
    ) {
      return
    }
    window.location = link.dataset.href
  })
})
